import { FC, ReactElement, useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import { Card, CardHeader } from "../Form.Status/Status.styled";
import CloseIcon from "../../assets/CloseIcon.svg";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import {
  CardContainer,
  Label2,
  SavedCards,
} from "../../../src/components/MoveOutTerminationTabs/MoveOut.styled";
import visa from "../../assets/visa.svg";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import General from "../../stores/GeneralStore";
import "../../../src/components/MoveOutTerminationTabs/temp.css";
import { observer } from "mobx-react";
import { toJS } from "mobx";

interface Obj {
  [key: string]: any;
  fromAutoPay: any;
}

interface Props extends BaseProps {
  changeCard: (data: any) => void;
  onClose?: React.MouseEventHandler<HTMLImageElement>;
  changeCardData: any;
}

const ChangeCardModal: FC<Props> = ({
  onClose,
  changeCardData,
  changeCard,
}: Props): ReactElement => {
  const [chosenCard, setChosenCard] = useState();
  const [chosenCardData, setChosenCardData] = useState<any>();

  const handleChangeCard = () => {
    changeCard(chosenCardData);
  };
  const handleOnChange = (card: any) => {
    const data = {
      paymentDate: changeCardData?.account?.paymentDate,
      accountId: changeCardData?.account?.accountNo,
      sourceId: card?.sourceId,
      previousPaymentId: card?.previousPaymentId,
      expiryYear: card?.expiryYear,
      expiryMonth: card?.expiryMonth,
      cardType: card?.cardType,
      cardNumber: card?.cardNumber,
      gatewayCdField: "NI",
      orderReferenceIdField: card?.orderReferenceId,
      cardHolderNameField: card?.cardHolderName 

    }
    // setChosenCardData({accounts:[{accountId:changeCardData?.account?.accountNo,paymentDate:changeCardData?.account?.paymentDate}],previousPaymentId:card?.previousPaymentId})
    setChosenCardData(data)
  }
  return (
    <Card
      style={{
        // overflow: "auto",
        margin: "20px auto",
        width: General?.isLargeScreen ? "33vw" : '100%',
        // height: "90vh",
        direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr",
      }}
    >
      {onClose ? (
        <CardHeader
          style={{
            justifyContent: "space-between",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background: General.contrast.contrastBackground
              ? General.contrast.contrastBackground
              : General?.ColorAss,
            height: '10%'
          }}
        >
          <h1
            style={{
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : '#fff',
              justifySelf: "flex-start",
              fontSize: `${2 * General.accessibility.fontSize}rem`,

            }}
          >
            {General?.codeLabels["cm_change_card"]?.label !== undefined
              ? General?.codeLabels["cm_change_card"]?.label
              : "Change Card"}
          </h1>
          <img src={CloseIcon} alt="" onClick={onClose} />
        </CardHeader>
      ) : null}
      <CardContent
        sx={{
          background: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0",
          marginTop: "0px",
        }}
      >
        <div style={{ width: General?.isLargeScreen ? "33vw" : '100%', padding: "20px", paddingBottom: "10px",height: "600px",
                    overflow: "auto", }}>
          {changeCardData?.card?.length > 0 ? <SavedCards>
            {changeCardData?.card?.map((card: any, index: any) => {
              return (
                <CardContainer
                  style={{
                    background: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : ""
                  }}
                  onClick={() => {
                    setChosenCard(index);
                    handleOnChange(card);
                  }}>
                  <section
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1.5em",

                    }}
                  >
                    <Label2>
                      <input onChange={(e) => { }} type="checkbox" checked={chosenCard === index} />
                      <svg viewBox="0 0 21 18">
                        <symbol
                          id="tick-path"
                          viewBox="0 0 21 18"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.22003 7.26C5.72003 7.76 7.57 9.7 8.67 11.45C12.2 6.05 15.65 3.5 19.19 1.69"
                            fill="none"
                            strokeWidth="2.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </symbol>
                        <defs>
                          <mask id="tick">
                            <use className="tick mask" href="#tick-path" />
                          </mask>
                        </defs>
                        <use
                          className="tick"
                          href="#tick-path"
                          stroke="currentColor"
                        />
                        <path
                          fill="white"
                          mask="url(#tick)"
                          d="M18 9C18 10.4464 17.9036 11.8929 17.7589 13.1464C17.5179 15.6054 15.6054 17.5179 13.1625 17.7589C11.8929 17.9036 10.4464 18 9 18C7.55357 18 6.10714 17.9036 4.85357 17.7589C2.39464 17.5179 0.498214 15.6054 0.241071 13.1464C0.0964286 11.8929 0 10.4464 0 9C0 7.55357 0.0964286 6.10714 0.241071 4.8375C0.498214 2.39464 2.39464 0.482143 4.85357 0.241071C6.10714 0.0964286 7.55357 0 9 0C10.4464 0 11.8929 0.0964286 13.1625 0.241071C15.6054 0.482143 17.5179 2.39464 17.7589 4.8375C17.9036 6.10714 18 7.55357 18 9Z"
                        />
                      </svg>
                      <svg className="lines" viewBox="0 0 11 11">
                        <path d="M5.88086 5.89441L9.53504 4.26746" />
                        <path d="M5.5274 8.78838L9.45391 9.55161" />
                        <path d="M3.49371 4.22065L5.55387 0.79198" />
                      </svg>
                    </Label2>
                    <img src={visa} alt="" />
                  </section>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}

                  >
                    <span style={{
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss
                    }}>{`XXXX XXXX XXXX ${card?.cardNumber}`}</span>
                    <span style={{
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss
                    }}>{`${card?.expiryMonth} / ${card?.expiryYear}`}</span>
                  </span>
                </CardContainer>
              );
            })}
          </SavedCards> : <>{General?.codeLabels["cm_nomore_acct_add"]?.label ? General?.codeLabels["cm_nomore_acct_add"]?.label : "No Saved Card Available Please Add First"}</>}


          <ButtonsContainer
            style={{
              width: "100%",
              marginTop: "1rem",
              display: 'flex',
              justifyContent: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? 'left' : 'right',
            }}>
            <ButtonSecondary
              style={{
                width: "45%",
                padding: "auto",
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : '#fff',
                background: General.contrast.contrastBackground
                  ? General.contrast.contrastBackground
                  : General?.ColorAss,
                fontSize: `${General.accessibility.fontSize}rem`,
              }}
              onClick={() => handleChangeCard()}
              disabled={!(changeCardData?.card?.length > 0)}
            //className={General?.colorClass}
            >
              {General?.codeLabels["cm_btncontinue"]?.label !== undefined
                ? General?.codeLabels["cm_btncontinue"]?.label
                : "Continue"}
            </ButtonSecondary>
          </ButtonsContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default observer(ChangeCardModal);
